import { useEffect, useState } from "react";
import WorkflowHistoryTimeline from "@/components/WorkflowHistoryTimeline";

export default function EnrollmentWorkflowTimeline({ studentEnrollmentId, loadHistory, isAdmin = false }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!studentEnrollmentId) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError("");
    loadHistory(studentEnrollmentId)
      .then((data) => active && setHistory(Array.isArray(data) ? data : []))
      .catch(() => active && setError("Unable to load workflow history."))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [studentEnrollmentId, loadHistory]);

  return <WorkflowHistoryTimeline rows={history} loading={loading} error={error} isAdmin={isAdmin} />;
}
